import {Messages} from "../../Messages";
import {SubscribeFlowController} from "./SubscribeFlowController";
import {startGiftSubscriptionFlow} from "./startFlow";
import {PANEL_VARIANT} from "../../../blink-sdk/Constants";
import {iFrameState} from "../../services/IFrameState";

export class GiftSubscriptionFlowController extends SubscribeFlowController {
    actionButtonTestId = "giftSubscriptionBtn";
    actionButtonDefaultAnid = "gift-subscription-button";
    logInFooterDefaultAnid = "gift-subscription-login-footer";

    onClickAuthenticated() {
        startGiftSubscriptionFlow();
    }

    onClickNotAuthenticated() {
        startGiftSubscriptionFlow();
    }

    onLoginClick() {
        startGiftSubscriptionFlow(PANEL_VARIANT.skipCTA);
    }

    getActionButtonDefaultLabel() {
        return iFrameState.panelButtonText || Messages.giftSubscription;
    }

    getLoginFooterMessage() {
        return Messages.alreadyHaveAnAccount;
    }
}
